import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {Bizinquiry} from '../../_data/reports/business/request/bizinquiry';
import {Router, RouterLink} from '@angular/router';
import {I18nService} from '../../_services/gui/i18n.service';
import {TabBarService} from '../../_services/gui/tab-bar.service';
import {BusinessReportsService} from '../../_services/data/reports/business-reports.service';
import {AddonsResult, BusinessPickListResponse, getAddon} from '../../_data/reports/business/response/business-pick-list';
import {
  BusinessOwner,
  BusinessOwnerAddress,
  BusinessOwnerName,
  BusinessReport,
  ReportBizAccount,
  ReportBizAddress,
  ReportBizAvsInfo,
  ReportBizBankruptcy,
  ReportBizCollection,
  ReportBizContact,
  ReportBizId,
  ReportBizInfoGroup,
  ReportBizInquiry,
  ReportBizLegal,
  ReportBizName,
  ReportBizOther,
  ReportBizPhone,
  ReportBizRegisteredItem
} from '../../_data/reports/business/response/business';
import {stringify} from 'flatted';
import {
  bankruptcyTypeI18nKey,
  chunkSubstr,
  equalsIgnoreCase,
  isNotBlank,
  kob,
  kobDefinitionI18nKey,
  mapCsvKvp,
  mapCsvKvpForCV4B,
  mopI18nKey,
  reformatDate,
  reformatDateMonth,
  reformatMonthDateYear,
  reformatPhone,
  reformatPostal,
  removeExtraWhitespace,
  removeTimeZone
} from '../../_utils/lang';
import moment from 'moment';
import {concat, Observable, of, Subscription, zip} from 'rxjs';
import {
  compareAddrSinceDtDesc,
  compareFiledDtLastUpdatedDtSerialNumberDesc,
  compareFileSinceDtDesc,
  compareFileSinceDtLastUpdatedDtSerialNumberDesc,
  compareInquiryDtDesc,
  compareLastSaleDateDesc,
  compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc,
  compareSerialDesc,
  compareTradeAcntRecencyDateDesc
} from '../../_utils/comparators';
import {first as firstFromCollection, isNotEmpty} from '../../_utils/collect';
import {NotificationService} from '../../_services/gui/notification.service';
import {first, map} from 'rxjs/operators';
import {UtilitiesService} from 'src/app/_services/data/utilities.service';
import {BizLumbSubTradeAccount, BizLumbSubTradeAccountDet} from '../../_data/reports/lumbermens/lumbermens-business';
import {BUSINESS_REQUEST_CACHE_KEY, BUSINESS_RESPONSE_CACHE_KEY} from '../../_constants/constants';
import {fromSessionOr} from '../../_utils/storage';
import {BusinessRequest} from '../../_data/reports/business/request/business-request';
import {isBusinessReport} from '../../_utils/type-guards';
import {getStateFromRouter} from '../../_utils/nav';
import {PdfReactorHeaderComponent} from '../../common/pdf-reactor-header/pdf-reactor-header.component';
import {BUSINESS_PDF_CSS} from '../../_constants/pdf-report/business-css';
import {SidenavComponent} from '../../sidenav/sidenav.component';
import {CardComponent} from '../../sidenav/card/card.component';
import {PdfButtonBarComponent} from '../../common/pdf-button-bar/pdf-button-bar.component';
import {NgTemplateOutlet, NgClass, AsyncPipe, UpperCasePipe, KeyValuePipe} from '@angular/common';
import {LumbermensTradeAccountDetComponent} from './lumbermens-trade-account-det/lumbermens-trade-account-det.component';
import {LumbermensAutomatedTradeSubmissionDetComponent} from './lumbermens-automated-trade-submission-det/lumbermens-automated-trade-submission-det.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-business-credit-report',
    templateUrl: './business-credit-report.component.html',
    styleUrls: ['./business-credit-report.component.scss'],
    imports: [SidenavComponent, PdfReactorHeaderComponent, CardComponent, RouterLink, PdfButtonBarComponent, NgTemplateOutlet, 
      NgClass, LumbermensTradeAccountDetComponent, LumbermensAutomatedTradeSubmissionDetComponent, AsyncPipe, UpperCasePipe, 
      KeyValuePipe, TranslateModule]
})
export class BusinessCreditReportComponent implements OnInit, OnDestroy {

  //Util methods used in the template
  removeTimeZone = removeTimeZone;
  // reformatDate = reformatDate;
  reformatDateMonth = reformatDateMonth;
  // reformatMonthDateYear = reformatMonthDateYear;
  reformatPhone = reformatPhone;
  reformatPostal = reformatPostal;
  kob = kob;
  equalsIgnoreCase = equalsIgnoreCase;
  isNotBlank = isNotBlank;

  _appCard: ElementRef;
  _creditReport: ElementRef;
  businessReportCss = BUSINESS_PDF_CSS;

  reportProcessed: boolean = false;
  noHitReport: boolean = false;
  bizInquiry: Bizinquiry;
  business: BusinessReport;

  creditScore: string;
  creditScoreRsn1: string;
  creditScoreRsn2: string;
  creditScoreRsn3: string;
  creditScoreRsn4: string;
  creditScoreAlert1: string;
  creditScoreAlert2: string;
  creditScoreAlert3: string;
  creditScoreAlert4: string;

  currentDate: string = moment().format('YYYY-MM-DD');
  currentLLL: string = moment().format('LLL');
  onFileDate: string;

  lastUpdatedDate: string;
  insolvencyPresent: boolean;
  inquiryQualifier: string;
  searchType: string;
  productDescription: string;

  owners: BusinessOwner[];
  numOfAccounts: number;
  numberOfEmployees: string;

  numberOfEmployeesReportedDt: string;
  legalName: ReportBizName;
  operatingName: ReportBizName;
  address: ReportBizAddress;
  prevAddresses: ReportBizAddress[];
  phone: ReportBizPhone;
  naicsValue: ReportBizOther;
  sicValue: ReportBizOther;
  entityType: ReportBizOther;
  businessId: ReportBizId;
  avsInfo: ReportBizAvsInfo;
  bizInfo: ReportBizInfoGroup;
  prevLegalNames: ReportBizName[];
  prevOperatingNames: ReportBizName[];
  contacts: ReportBizContact[];
  inquiries: ReportBizInquiry[];
  accounts: ReportBizAccount[];
  bankruptcies: ReportBizBankruptcy[];
  legals: ReportBizLegal[];
  registeredItems: ReportBizRegisteredItem[];

  collections: ReportBizCollection[];
  lumbermens: AddonsResult;
  lumbermensTradeAccountsByRecency: BizLumbSubTradeAccount[];
  lumbermensTradeAccountsByLastSale: BizLumbSubTradeAccount[];
  mergedLumberRecency = [];
  mergedLumberLastSale = [];
  businessIDMismatch: AddonsResult;
  creditFreezeOwners = [];
  // private readonly businessPicklistRow: BusinessPicklistRow;

  i18nService = inject(I18nService);

  private getAacDescriptionsSubscription: Subscription;
  // TODO: (feature) if inqAndBusiness null (not passed from order / user manually typed path or refreshed screen)
  //  - redirect back to order screen?  Temporarily store info in sessionStorage?

  private readonly requestBid: number;
  private router = inject(Router);
  private tabBarService = inject(TabBarService);
  private notificationService = inject(NotificationService);
  private businessesService = inject(BusinessReportsService);
  private utilitiesService = inject(UtilitiesService);
  private cdRef = inject(ChangeDetectorRef);
  constructor() {
    const router = this.router;


    //First, pull from the router state if it's there (coming here from the picklist)
    //Second, pull from the sessionStorage if it's there (coming here from a refresh)
    //Third, if nothing, forward back to the order page (coming here manually when the user shouldn't be)
    const businessRequest: BusinessRequest = getStateFromRouter(router) ?? JSON.parse(sessionStorage.getItem(BUSINESS_REQUEST_CACHE_KEY));
    //Store in sessionStorage so that if we're in point #1 above, point #2 works later.
    //Will, of course, be redundant if it's from the sessionStorage already
    sessionStorage.setItem(BUSINESS_REQUEST_CACHE_KEY, JSON.stringify(businessRequest));

    if(!businessRequest) {
      router.navigateByUrl('/business-services');
    }

    this.bizInquiry = businessRequest.bizInquiry;
    if(businessRequest.business !== null) {
      if(isBusinessReport(businessRequest.business)) {
        this.requestBid = businessRequest.business.bid;
      } else {
        this.requestBid = businessRequest.business.id;
      }
    } else {
      // No Hit Scenario
      this.requestBid = null;
    }

    this.inquiryQualifier = businessRequest.inquiryQualifier;
    this.searchType = businessRequest.searchType;
    this.productDescription = businessRequest.productDescription;

  }

  private static getMostRecentNameByType(bizNames: ReportBizName[], type: string): ReportBizName {
    return firstFromCollection(bizNames.filter(value => value.type === type).sort(compareFileSinceDtDesc()));
  }

  private static getMostRecentPhone(bizPhones: ReportBizPhone[]): ReportBizPhone {
    bizPhones.sort(compareFileSinceDtDesc());
    return firstFromCollection(bizPhones);
  }

  private static getBizOtherByType(bizOthers: ReportBizOther[], type: string): ReportBizOther {
    return firstFromCollection(bizOthers.filter(b => b.type === type));
  }

  private static getSicBizOther(bizOthers: ReportBizOther[]): ReportBizOther {
    return BusinessCreditReportComponent.getBizOtherByType(bizOthers, '8');
  }

  private static getNaicsBizOther(bizOthers: ReportBizOther[]): ReportBizOther {
    return BusinessCreditReportComponent.getBizOtherByType(bizOthers, '9');
  }

  private static getEntityTypeBizOther(bizOthers: ReportBizOther[]): ReportBizOther {
    return BusinessCreditReportComponent.getBizOtherByType(bizOthers, '12');
  }

  private static getNumberOfEmployeesBizOther(bizOthers: ReportBizOther[]): ReportBizOther {
    return BusinessCreditReportComponent.getBizOtherByType(bizOthers, '10');
  }

  private static getMostRecentBizIdByType(bizIds: ReportBizId[], type: string): ReportBizId {
    return firstFromCollection(bizIds.filter(b => b.idType === type).sort(compareFileSinceDtLastUpdatedDtSerialNumberDesc()));
  }

  private static getMostRecentAvsInfo(bizAvsInfo: ReportBizAvsInfo[]): ReportBizAvsInfo {
    bizAvsInfo.sort(compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc());
    return firstFromCollection(bizAvsInfo);
  }

  private static getMostRecentBizInfoGroup(bizInfoGroups: ReportBizInfoGroup[]): ReportBizInfoGroup {
    bizInfoGroups.sort(compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc());
    return firstFromCollection(bizInfoGroups);
  }

  private static getBizNamesByType(bizNames: ReportBizName[], type: string): ReportBizName[] {
    return bizNames.filter(bizName => bizName.type === type).sort(compareFileSinceDtLastUpdatedDtSerialNumberDesc());
  }

  private pullReport() {

    this.bizInquiry.meta.picklistOnly = false;
    this.bizInquiry.meta.bid = this.requestBid;

    fromSessionOr(BUSINESS_RESPONSE_CACHE_KEY, this.businessesService.getBusinessFromPickList({bizinquiry: this.bizInquiry}))
      .subscribe((b: BusinessPickListResponse) => {
        if(b) {
          if(b.business === null && (b.addonsResults && !b.addonsResults.length)) {
            this.bizInquiry = b.bizinquiry;
            this.noHitReport = true;
            console.log('No Hit - business and addonResults are empty');
            return;
          }

          this.bizInquiry = b.bizinquiry;
          this.business = b.business;

          if(this.business) {
            this.loadFileDates(b);
            this.loadIdentificationInformation(b);
            this.loadAdditionalBusinessInformation(b);
            this.loadCreditFreezeInformation(b);

            //Load other lists of items
            b.business.owners.sort(compareFileSinceDtLastUpdatedDtSerialNumberDesc());
            b.business.bizInquiries.sort(compareInquiryDtDesc());
            b.business.bizAccounts.sort(compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc());
            b.business.bizBankruptcies.sort(compareFiledDtLastUpdatedDtSerialNumberDesc());
            b.business.bizLegals.sort((reportBizLegalA: ReportBizLegal, reportBizLegalB: ReportBizLegal) => {
              const comparison = moment(reportBizLegalB.judgementDt).valueOf() - moment(reportBizLegalA.judgementDt).valueOf();
              return comparison === 0 ? reportBizLegalB.caseNumber.localeCompare(reportBizLegalA.caseNumber) : comparison;
            });
            b.business.bizRegistereditems.sort(compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc());
            b.business.bizCollections.sort(compareLastUpdatedDtPostedDtFileSinceDtSerialNumberDesc());

            this.owners = b.business.owners;
            this.inquiries = b.business.bizInquiries;
            this.accounts = b.business.bizAccounts;
            this.bankruptcies = b.business.bizBankruptcies;
            this.legals = b.business.bizLegals;
            this.registeredItems = b.business.bizRegistereditems;
            this.collections = b.business.bizCollections;
          }

          this.loadCreditScore(b);
          this.loadLumbermens(b);          
          this.loadBizIDMismatch(b);

        }

        this.reportProcessed = true;

      });

  }

  private loadCreditScore(b: BusinessPickListResponse) {
    const scoreAddon: AddonsResult = getAddon(b, '00095');
    if(scoreAddon) {
      const messageMap = mapCsvKvp(scoreAddon.message);
      this.creditScore = messageMap.TBSSC100;
      this.getAacDescriptionsSubscription?.unsubscribe();
      this.getAacDescriptionsSubscription = this.i18nService.repeatOnLangChange(() => this.utilitiesService.getAacDescriptions('00095')).subscribe(aac => {
        if(messageMap.TBSSC102 !== '0') {
          this.creditScoreRsn1 = aac[messageMap.TBSSC102] || messageMap.TBSSC102;
        }
        if(messageMap.TBSSC103 !== '0') {
          this.creditScoreRsn2 = aac[messageMap.TBSSC103] || messageMap.TBSSC103;
        }
        if(messageMap.TBSSC104 !== '0') {
          this.creditScoreRsn3 = aac[messageMap.TBSSC104] || messageMap.TBSSC104;
        }
        if(messageMap.TBSSC105 !== '0') {
          this.creditScoreRsn4 = aac[messageMap.TBSSC105] || messageMap.TBSSC105;
        }
      });
    }

    const cv4bBusiness: AddonsResult = getAddon(b, '00103');
    if(cv4bBusiness) {
      const messageMap = mapCsvKvpForCV4B(cv4bBusiness.message);
      this.creditScore = messageMap.CV4BSC100;
      this.getAacDescriptionsSubscription?.unsubscribe();
      this.getAacDescriptionsSubscription = this.i18nService.repeatOnLangChange(() => this.utilitiesService.getAacDescriptions('00103')).subscribe(aac => {
        if(messageMap.CV4BSC102 !== '0') {
          this.creditScoreRsn1 = aac[messageMap.CV4BSC102] || messageMap.CV4BSC102;
        }
        if(messageMap.CV4BSC103 !== '0') {
          this.creditScoreRsn2 = aac[messageMap.CV4BSC103] || messageMap.CV4BSC103;
        }
        if(messageMap.CV4BSC104 !== '0') {
          this.creditScoreRsn3 = aac[messageMap.CV4BSC104] || messageMap.CV4BSC104;
        }
        if(messageMap.CV4BSC105 !== '0') {
          this.creditScoreRsn4 = aac[messageMap.CV4BSC105] || messageMap.CV4BSC105;
        }
      });
    }

    const cv4bBusinessAndOwner: AddonsResult = getAddon(b, '00102');
    if(cv4bBusinessAndOwner) {
      const messageMap = mapCsvKvpForCV4B(cv4bBusinessAndOwner.message);
      this.creditScore = messageMap.CV4BSC200;
      this.getAacDescriptionsSubscription?.unsubscribe();
      this.getAacDescriptionsSubscription = this.i18nService.repeatOnLangChange(() => this.utilitiesService.getAacDescriptions('00102'))
        .subscribe(aac => {
          if(messageMap.CV4BSC202 !== '0') {
            this.creditScoreRsn1 = aac[messageMap.CV4BSC202] || messageMap.CV4BSC202;
          }
          if(messageMap.CV4BSC203 !== '0') {
            this.creditScoreRsn2 = aac[messageMap.CV4BSC203] || messageMap.CV4BSC203;
          }
          if(messageMap.CV4BSC204 !== '0') {
            this.creditScoreRsn3 = aac[messageMap.CV4BSC204] || messageMap.CV4BSC204;
          }
          if(messageMap.CV4BSC205 !== '0') {
            this.creditScoreRsn4 = aac[messageMap.CV4BSC205] || messageMap.CV4BSC205;
          }
          this.creditScoreAlert1 = aac[messageMap.CV4BSC207] || messageMap.CV4BSC207;
          this.creditScoreAlert2 = aac[messageMap.CV4BSC208] || messageMap.CV4BSC208;
          this.creditScoreAlert3 = aac[messageMap.CV4BSC209] || messageMap.CV4BSC209;
          this.creditScoreAlert4 = aac[messageMap.CV4BSC210] || messageMap.CV4BSC210;
        });
    }
  }

  private loadFileDates(b: BusinessPickListResponse) {
    this.onFileDate = moment(b.business.fileSinceDt).format('YYYY-MM-DD');
    const lastUpdatedDuration: moment.Duration = moment.duration(moment().diff(moment(b.business.lastUpdatedDt)));

    const yearsI18nKey = lastUpdatedDuration.years() === 1 ? 'content.year-singular' : 'content.year-plural';
    const monthsI18nKey = lastUpdatedDuration.months() === 1 ? 'content.month-singular' : 'content.month-plural';

    zip(
      this.i18nService.getTranslation(yearsI18nKey, {years: lastUpdatedDuration.years()}),
      this.i18nService.getTranslation(monthsI18nKey, {months: lastUpdatedDuration.months()})
    ).subscribe(translations => {
      this.lastUpdatedDate = `${translations[0]}, ${translations[1]}`;
    });
  }

  private loadIdentificationInformation(b: BusinessPickListResponse) {

    this.legalName = BusinessCreditReportComponent.getMostRecentNameByType(b.business.bizNames, 'L');
    this.operatingName = BusinessCreditReportComponent.getMostRecentNameByType(b.business.bizNames, 'O');
    b.business.bizAddresses.sort(compareAddrSinceDtDesc());
    this.prevAddresses = b.business.bizAddresses;
    this.address = firstFromCollection(this.prevAddresses);
    this.phone = BusinessCreditReportComponent.getMostRecentPhone(b.business.bizPhones);

    this.naicsValue = BusinessCreditReportComponent.getNaicsBizOther(b.business.bizOthers);
    this.sicValue = BusinessCreditReportComponent.getSicBizOther(b.business.bizOthers);
    this.entityType = BusinessCreditReportComponent.getEntityTypeBizOther(b.business.bizOthers);

    this.numOfAccounts = b.business.bizAccounts.length;
    this.insolvencyPresent = b.business.bizBankruptcies.length > 0;

    this.businessId = BusinessCreditReportComponent.getMostRecentBizIdByType(b.business.bizIds, 'CN');
    this.avsInfo = BusinessCreditReportComponent.getMostRecentAvsInfo(b.business.bizAvsInfos);

  }

  private loadCreditFreezeInformation(b: BusinessPickListResponse) {
    this.creditFreezeOwners = b?.bizinquiry?.owners;
    if(this.creditFreezeOwners.length > 0) {
      this.creditFreezeOwners = this.creditFreezeOwners.filter(owner => owner?.freezeFlag === 'Y');
    }
  }

  private loadAdditionalBusinessInformation(b: BusinessPickListResponse) {
    this.bizInfo = BusinessCreditReportComponent.getMostRecentBizInfoGroup(b.business.bizInfoGroups);
    const bizOtherEmployeeNum: ReportBizOther = BusinessCreditReportComponent.getNumberOfEmployeesBizOther(b.business.bizOthers);
    if(bizOtherEmployeeNum && bizOtherEmployeeNum.value && bizOtherEmployeeNum.value !== '') {
      this.numberOfEmployees = bizOtherEmployeeNum.value;
      this.numberOfEmployeesReportedDt = bizOtherEmployeeNum.lastUpdatedDt;
    } else {
      if(this.bizInfo != null) {
        this.numberOfEmployees = this.bizInfo.igCorpEmpSizeCd;
        this.numberOfEmployeesReportedDt = this.bizInfo.reportedDt;
      }
    }
    this.prevLegalNames = BusinessCreditReportComponent.getBizNamesByType(b.business.bizNames, 'L');
    this.prevOperatingNames = BusinessCreditReportComponent.getBizNamesByType(b.business.bizNames, 'O');
    b.business.bizContacts.sort(compareFileSinceDtLastUpdatedDtSerialNumberDesc());
    this.contacts = b.business.bizContacts;
  }

  private loadLumbermens(b: BusinessPickListResponse) {
    this.lumbermens = getAddon(b, 'B1900');
    if(this.lumbermens?.lumbermenBusinesses?.[0]?.bizLumbSubTradeAccount) {
      this.lumbermens.lumbermenBusinesses.forEach(lumbermanBusiness => {
        lumbermanBusiness.bizLumbSubTradeAccount.sort(compareTradeAcntRecencyDateDesc());
        this.lumbermensTradeAccountsByRecency = lumbermanBusiness.bizLumbSubTradeAccount;
        this.mergedLumberRecency.push(this.lumbermensTradeAccountsByRecency);
        lumbermanBusiness.bizLumbSubTradeAccount.sort(compareLastSaleDateDesc());
        this.lumbermensTradeAccountsByLastSale = lumbermanBusiness.bizLumbSubTradeAccount;
        this.mergedLumberLastSale.push(this.lumbermensTradeAccountsByLastSale);
      });
    } else {
      this.lumbermensTradeAccountsByRecency = [];
      this.lumbermensTradeAccountsByLastSale = [];
    }
  }
  
  private loadBizIDMismatch(b: BusinessPickListResponse) {
    this.businessIDMismatch = getAddon(b, '05501');

  }

  ngOnInit() {
    this.i18nService.setTitle('title.business-report');
    this.tabBarService.show();

    if(this.bizInquiry) {
      this.pullReport();
    } else {
      console.warn('bizInquiry not set!');
    }

  }

  ngOnDestroy(): void {
    this.getAacDescriptionsSubscription?.unsubscribe();
    //If the user intentionally navigates away from the report, clear the storage for the request/response.
    sessionStorage.removeItem(BUSINESS_REQUEST_CACHE_KEY);
    sessionStorage.removeItem(BUSINESS_RESPONSE_CACHE_KEY);
  }

  getRsnCodeDescriptions(): Observable<Map<string, string>> {
    return this.businessesService.getReasonDescriptions(this.creditScoreRsn1, this.creditScoreRsn2, this.creditScoreRsn3, this.creditScoreRsn4)
      .pipe(map(o => new Map(Object.entries(o))));
  }

  anyCreditScoreAlert(): boolean {
    return !!this.creditScoreAlert1 || !!this.creditScoreAlert2 || !!this.creditScoreAlert3 || !!this.creditScoreAlert4;
  }

  anyCreditScoreReason(): boolean {
    return !!this.creditScoreRsn1 || !!this.creditScoreRsn2 || !!this.creditScoreRsn3 || !!this.creditScoreRsn4;
  }

  anyCreditScoreInfo(): boolean {
    return !!this.creditScore || this.anyCreditScoreAlert() || this.anyCreditScoreReason();
  }

  isBusinessActive(): boolean {
    return this.avsInfo && this.avsInfo.avsCorpStatusCd === 'Y';
  }

  formatOwnerName(ownerName: BusinessOwnerName): string {
    const f = ownerName.first ? ownerName.first : '';
    const m = ownerName.middle ? ownerName.middle : '';
    const l = ownerName.last ? ownerName.last : '';
    return removeExtraWhitespace(`${f} ${m} ${l}`);
  }

  formatAddress(a: BusinessOwnerAddress | ReportBizAddress): string {
    const apt = a.apt ? a.apt : '';
    const civic = a.civic ? ` - ${a.civic}` : '';
    return removeExtraWhitespace(`${apt} ${civic} ${a.street}, ${a.city}, ${a.prov}, ${a.postal}`);
  }

  formatDate(dt: moment.MomentInput): string {
    return reformatDate(removeTimeZone(dt));
  }

  formatMonthDateYear(dt: moment.MomentInput): string {
    return reformatMonthDateYear(removeTimeZone(dt));
  }

  /** Split the payment pattern into lines no longer than 24 characters */
  formatPaymentPattern(item: string): string[] {
    return chunkSubstr(item, 24);
  }

  getOwnerPercent(owner: BusinessOwner): number {
    owner.ownerBizAssocs.sort(compareSerialDesc());
    const businessOwnerAssoc = firstFromCollection(owner.ownerBizAssocs);
    return businessOwnerAssoc && businessOwnerAssoc.pctOwnership ? businessOwnerAssoc.pctOwnership / 100 : null;
  }

  getAccountType(account: ReportBizAccount): Observable<string> {
    if(account.acctType === 'I') {
      return this.i18nService.getTranslation('content.installment');
    } else if(account.acctType === 'R') {
      return this.i18nService.getTranslation('content.revolving');
    } else if(account.acctType === 'O') {
      return this.i18nService.getTranslation('content.open');
    } else if(account.acctType === 'M') {
      return this.i18nService.getTranslation('content.mortgage');
    } else {
      return of('');
    }
  }

  getKobDefinition(memberCode: string): Observable<string> {

    const definitionObs = this.i18nService.getTranslation(kobDefinitionI18nKey(memberCode));
    const otherDefinitionObs = this.i18nService.getTranslation('content.other');

    return concat(definitionObs, otherDefinitionObs).pipe(first(value => !!value));

  }

  getMopDescription(mopCode: string): Observable<string> {
    return this.i18nService.getTruthyTranslation(mopI18nKey(mopCode), '');
  }

  countPaymentPat(paymentPat: string, codesToCount: string[]): number {
    let count = 0;
    [...codesToCount].forEach(c => count += paymentPat.split(c).length - 1);
    return count;
  }

  getBankruptcyDefinition(bankruptcyCode: string): Observable<string> {
    //If the code is a certain one (01, 02, 03, 04) get the description from the translation files.
    //Otherwise, just use the code itself.
    return this.i18nService.getTruthyTranslation(bankruptcyTypeI18nKey(bankruptcyCode), bankruptcyCode);
  }

  getChattelValue(reportBizRegisteredItem: ReportBizRegisteredItem, key: string) {
    if(reportBizRegisteredItem.chattels && reportBizRegisteredItem.chattels.length > 0) {
      return reportBizRegisteredItem.chattels[0][key];
    } else {
      return null;
    }
  }

  getChattelTypeDescription(reportBizRegisteredItem: ReportBizRegisteredItem): Observable<string> {
    const chattelType = this.getChattelValue(reportBizRegisteredItem, 'type');
    if(chattelType && chattelType.trim() !== '') {
      if(chattelType === 'MV') {
        return this.i18nService.getTranslation('content.motor-vehicle');
      } else {
        return of(chattelType);
      }
    } else {
      return this.i18nService.getTranslation('content.unknown');
    }
  }

  displayOwnerNsbe(): boolean {
    return ['05000', '05002', '05004'].findIndex(value => value === this.bizInquiry.meta.product) === -1;
  }

  displayLumbermensQuickView(): boolean {
    return this.lumbermens && isNotEmpty(this.lumbermens.lumbermenBusinesses) && !!this.lumbermens.lumbermenBusinesses[0].bizLumbQuickView;
  }

  getLumbermensQuickView(key: string): string {
    if(!this.displayLumbermensQuickView()) {
      return null;
    }
    return this.lumbermens.lumbermenBusinesses[0].bizLumbQuickView[0][key];
  }

  getLumbermensTradeDet(account: BizLumbSubTradeAccount): BizLumbSubTradeAccountDet {
    account.bizLumbSubTradeAccountDet.sort(compareTradeAcntRecencyDateDesc());
    return firstFromCollection(account.bizLumbSubTradeAccountDet);
  }

  getLumbermensTradeName(account: BizLumbSubTradeAccount): string {
    const bizLumbSubTradeAccountDet = this.getLumbermensTradeDet(account);
    if(!bizLumbSubTradeAccountDet || !bizLumbSubTradeAccountDet.sicCode) {
      return null;
    }
    const sicDesc = this.i18nService.currentLangShortCode === 'FR' ? bizLumbSubTradeAccountDet.sicFrenchDescription : bizLumbSubTradeAccountDet.sicEnglishDescription;
    return sicDesc ? `${bizLumbSubTradeAccountDet.sicCode}/${sicDesc}` : null;
  }

  @ViewChild('creditReport', {read: ElementRef})
  set creditReport(value: ElementRef) {
    this._creditReport = value;
    this.cdRef.detectChanges();
  }

  @ViewChild(PdfReactorHeaderComponent, {read: ElementRef})
  set appCard(appCard: ElementRef) {
    this._appCard = appCard;
    this.cdRef.detectChanges();
  }
}
